import React, { useEffect } from 'react';
import { ProgramsCTABand } from './programs/ProgramsCTABand';
import { ProgramsHero } from './programs/ProgramsHero';
import { ProgramsList } from './programs/ProgramsList';
import { ProgramsPricing } from './programs/ProgramsPricing';
import { ProgramsFAQHeader } from './programs/ProgramsFAQHeader';
import { ProgramsFAQQuestions } from './programs/ProgramsFAQQuestions';
import { ProgramsFAQActions } from './programs/ProgramsFAQActions';
export function Programs() {
  useEffect(() => {
    document.title = 'Martial Arts Programs | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2845">
      <ProgramsHero data-id="element-2846" />
      <ProgramsList data-id="element-2847" />
      <ProgramsPricing data-id="element-2848" />
      <section className="py-24 bg-off-white" data-id="element-2849">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2850">
          <ProgramsFAQHeader data-id="element-2851" />
          <ProgramsFAQQuestions data-id="element-2852" />
          <ProgramsFAQActions data-id="element-2853" />
        </div>
      </section>
      <ProgramsCTABand data-id="element-2854" />
    </div>;
}